import {translate} from 'vue-gettext'
import axios from 'axios'

const TRANSLATIONS_ENDPOINT = process.env.VUE_APP_TRANSLATIONS_ENDPOINT

/**
 * At the moment, the vue-gettext plugin does not have complete support
 * for applying translations to plain JavaScript files outside the context
 * of Vue. This is a workaround that allows us to generate translations for
 * our supported languages in plain JavaScript modules.
 *
 * Note that the configuration here should be kept up to date with the
 * configuration of the vue-gettext plugin in main.js.
 */
const config = {
  language: 'en',
  getTextPluginSilent: false,
  getTextPluginMuteLanguages: [],
  silent: false,
}

const getTranslations = () => {
  const promise = axios.get(TRANSLATIONS_ENDPOINT)
  return promise
    .then(res => {
      return res.data
      translate.initTranslations(res.data, config)
    })
    .catch(err => {
      console.error('Translations Error')
      console.error(err)
    })
}

getTranslations()

const gettext = translate.gettext.bind(translate)

export {gettext, translate, getTranslations}
